import React, { Component } from 'react';
import { connect } from 'react-redux';
import {bannerStyle} from './banner-styles';
import PropTypes from 'prop-types';

class Banner extends Component {

  getText() {
    return this.props.discount.text;
  }

  getColor() {
    return this.props.discount.textColor;
  }

  getBgColor() {
    return this.props.discount.bannerColor;
  }

  render() {
    return (
        <div style={
          {...bannerStyle, 
            ...{
              color: `#${this.getColor()}`, 
              background: `#${this.getBgColor()}`, 
            }
          }}>{this.getText()}</div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {     
  };
};

Banner.propTypes = {
  discount: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps) (Banner);



// WEBPACK FOOTER //
// ./src/components/Banner/banner.jsx